import cleanUrl from 'core/axios/cleanUrl';

const addURLSlashesInterceptors = client => {
  client.interceptors.request.use(request => {
    request.url = cleanUrl(request.url); // eslint-disable-line no-param-reassign
    return request;
  });

  return client;
};

export default addURLSlashesInterceptors;
